// extracted by mini-css-extract-plugin
export default {"container":"pact-order-failed_container__81749","message":"pact-order-failed_message__22b31"};